import { useMemo } from 'react';

export const useCommonTags = (products, selectedProductIds) => {
	return useMemo(() => {
		if (products.length === 0 || selectedProductIds.length === 0) return [];
		const filteredList = products.filter((product) => selectedProductIds.includes(product.id));
		if (filteredList.length === 0) return [];
		for (let i = 0; i < filteredList.length; i++) {
			if (!filteredList[i].tagResponseList || filteredList[i].tagResponseList.length === 0) {
				return [];
			}
		}
		const validProducts = filteredList.filter((product) => product.tagResponseList);
		if (validProducts.length === 0) return [];
		const commonTags = validProducts[0].tagResponseList;

		return commonTags.filter((tag) =>
			validProducts.every((item) => item.tagResponseList.some((t) => t.id === tag.id))
		);
	}, [products, selectedProductIds]);
};
